const GetDataSource = `
  query Query($id: String!) {
    dataSource(id: $id) {
      id
      name
      description
      type
      sender {
        id
        name
        description
      }
      receiver {
        id
        name
        description
      }
      dataType {
        id
        name
        description
      }
      config {
        ... on DataSourceSFTPConfig {
          endpoint
          path
          pollingInterval
          fileMask
          recursive
          staticMetadata {
            key
            value
          }
          ignoreGatewayDedupe
          includeFileHash
        }
        ... on DataSourceFTPConfig {
          endpoint
          path
          pollingInterval
          fileMask
          recursive
          staticMetadata {
            key
            value
          }
          ignoreGatewayDedupe
          includeFileHash
        }
        ... on DataSourceHTTPConfig {
          endpoint
          path
          method
          response
          responseCode
          headers {
            key
            value
          }
          staticMetadata {
            key
            value
          }
        }
      }
    }
  }
`

const GetDataSources =
  `query Query($count: Int, $cursor: String, $filterConfig: DataSourceFilterConfigInput) {
    dataSources(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          description
          type
          sender {
            id
            name
            description
          }
          receiver {
            id
            name
            description
          }
          dataType {
            id
            name
            description
          }
          config {
            ... on DataSourceSFTPConfig {
              endpoint
              path
              pollingInterval
              fileMask
              recursive
            }
            ... on DataSourceFTPConfig {
              endpoint
              path
              pollingInterval
              fileMask
              recursive
            }
          }
        }
      }
    }
  }
  `

module.exports = {
  GetDataSource,
  GetDataSources,
}
